import config from 'src/config';

const BROWSER_ORIGIN =
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'http://localhost';

/**
 * Resolves `REACT_APP_API_BASE_URL` to an absolute prefix (no trailing slash)
 * before the `v1/workflow-triggers/...` segment.
 */
function resolveTriggerApiAbsolutePrefix(): string {
  const rawBase = (config.apiBaseUrl ?? '').trim();

  if (!rawBase) {
    return new URL('/api', BROWSER_ORIGIN).href.replace(/\/$/, '');
  }

  const base = rawBase.replace(/\/$/, '');
  if (base.startsWith('http://') || base.startsWith('https://')) {
    return base;
  }

  const path = base.startsWith('/') ? base : `/${base}`;
  return new URL(path, BROWSER_ORIGIN).href.replace(/\/$/, '');
}

function absoluteTriggerUrl(pathWithinApi: string): string {
  const segment = pathWithinApi.replace(/^\//, '');
  return `${resolveTriggerApiAbsolutePrefix()}/${segment}`;
}

/**
 * Absolute URL for `POST …/v1/workflow-triggers/:workflowId/start`.
 *
 * Uses `config.apiBaseUrl` (`REACT_APP_API_BASE_URL`): either an absolute URL
 * (e.g. `http://localhost:8080/api`) or a path prefix (e.g. `/api` under Vite
 * dev proxy). Falls back to `/api` on the current origin when unset.
 */
export function getWorkflowTriggerStartUrl(workflowId: string): string {
  return absoluteTriggerUrl(`v1/workflow-triggers/${workflowId}/start`);
}

/**
 * Absolute URL for `GET …/v1/workflow-triggers/runs/:runId` (token-authenticated
 * status polling for runs created via the trigger POST).
 */
export function getWorkflowTriggerRunPollUrl(runId: string): string {
  return absoluteTriggerUrl(`v1/workflow-triggers/runs/${runId}`);
}
